define.alias("shared/components/shared/bttp/bttp-suggestions", "calendar/components/shared/bttp/bttp-suggestions");